import { render, staticRenderFns } from "./landingLogin.vue?vue&type=template&id=5738f706"
import script from "./landingLogin.vue?vue&type=script&lang=js"
export * from "./landingLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports